import { React, useEffect, useState, useRef, useMemo } from "react";
import { getPatientRequests } from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import { genericGet, genericPost } from "../../services/Api";
import {   ENDPOINTS } from "../../Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
const RedemptionSummary = (props) => {
  const history = useHistory();
 
  const [loading, setLoading] = useState(false);
  const [cycle_id, setCycle_id] = useState(null);

  const [rowData, setRowData] = useState([]
);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [active_cycles, setActive_cycles] = useState([])

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

  useEffect(() => {
    
    list_active_cycles();

    return () => {};
  }, []);

  const list_active_cycles = () => {
    
    setLoading(true)
   
   genericGet(ENDPOINTS.GET_ACTIVE_CYCLES)
   .then((res) => {
     setLoading(false)
 
       if (res.status == 200) {
           if (res.data.status == SUCCESS_RESULT) {
               let responseData = res.data.data;
               setActive_cycles(responseData);
             
               console.clear();
               console.log(responseData)
         
           } else {
               cogoToast.error(res.data.message, {});
               

           }
       }
   })
   .catch((err) => {
     setLoading(false)
       cogoToast.error(err, {});

       console.log(err);
   });
  
 };
  const getSummaryData = (cycle_id) => {
    setLoading(true);

    let payload = {
      cycle_id: cycle_id,
      
    };
    genericPost(ENDPOINTS.REDEMPTIONS_PER_CYCLE ,payload)
    .then((res) => {
      setLoading(false)
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
         setRowData(responseData);
               
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
      setLoading(false)
        cogoToast.error(err, {});
   
        console.log(err);
    });
     
  };

  return (
    <div>
      <h1>    Redemption Summary</h1>


      {/* {JSON.stringify(room)} */}
      <Breadcrumb className="ms-1">
        <BreadcrumbItem>
          <Link to="/hmis"> HMIS </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link to="/hmis">Redemptions</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>
          <span> Summary </span>
        </BreadcrumbItem>
      </Breadcrumb>
      <div className="d-flex justify-content-center my-1">
        {loading && <Spinner />}
      </div>
      <div className="card-body">
        <div className="ag-theme-alpine">
          <b>Select Cycle</b> <br/>
    <select className="form-control" onChange={(e)=>{

  
 
  getSummaryData(e.target.value);

  
}}>
  <option>..</option>
  {active_cycles?.map((s)=>{
    return   <option value={s.cycle_id} >{s.cycle_name}</option>
  })}

</select>
<br/>
          <AgGridReact
            suppressMenuHide={true}
            
            ref={gridRef}
      

           
            onGridReady={(params) => {
              setGridApi(params.api);
              // params.api.showLoadingOverlay();
            }}
            rowData={rowData}
            domLayout={"autoHeight"}
            animateRows={true}
            pagination={true}
            paginationPageSize={100}
            defaultColDef={defaultColDef}
            resizable={true}
            enableCellTextSelection={true}
            suppressCellSelection={true}
            columnDefs={[
              {
                headerName: "#",
                filter: false,
                maxWidth: 70,
                sortable: true,
                valueFormatter: function (params) {
                  return `${parseInt(params.node.id) + 1}`;
                },
              },
              {
                headerName: "Service center name",
                field: "service_center_name",
                sortable: true,
                filter: true,
              },
              {
                headerName: "total services",
                field: "total_services",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Total bnf ",
                field: "total_bnf",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Total redemption",
                field: "total_redemption",
                sortable: true,
                filter: true,
              },

              {
                headerName: "Total bnf cash",
                field: "total_bnf_cash",
                sortable: true,
                filter: true,
              },
              {
                headerName: "Total bnf cash",
                field: "total_bnf_cash",
                sortable: true,
                filter: true,
              }, {
                headerName: "Total discount allowed",
                field: "total_discount_allowed",
                sortable: true,
                filter: true,
              },


            


            ]}
          ></AgGridReact>
        </div>
      </div>
      ;
    </div>
  );
};

export default RedemptionSummary;
